import Styleguide from "@store/Framework/Types/Styleguide";

const textArea: Styleguide["textArea"] = {};

export default textArea;
